import { createAction, props } from '@ngrx/store';
import { MyBookingState } from './my-booking.state';

/** StateDetailsActions */
const ACTION_SET = '[MyBooking] set';
const ACTION_UPDATE = '[MyBooking] update';

/**
 * Clear the current store object and replace it with the new one
 */
export const setMyBooking = createAction(ACTION_SET, props<MyBookingState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateMyBooking = createAction(ACTION_UPDATE, props<Partial<MyBookingState>>());
